export function formatNumber(num: number): string {
  const wholePart = Math.floor(num);
  const decimalPart = num - wholePart;

  const fractionMap: { [key: string]: string } = {
    '0.125': '1/8',
    '0.25': '1/4',
    '0.37': '3/8',

    /** All close enough to be shown as 1/3 */
    '0.32': '1/3',
    '0.33': '1/3',
    '0.34': '1/3',

    /** All close enough to be shown as 2/3 */
    '0.65': '2/3',
    '0.66': '2/3',
    '0.67': '2/3',

    '0.5': '1/2',
    '0.62': '5/8',
    '0.75': '3/4',
    '0.87': '7/8',
  };

  if (decimalPart === 0) {
    return wholePart.toString();
  } else if (decimalPart in fractionMap) {
    return wholePart
      ? `${wholePart} ${fractionMap[decimalPart]}`
      : fractionMap[decimalPart];
  } else {
    const rounded = Math.round(num * 100) / 100;
    return rounded.toFixed(2);
  }
}
